import React from 'react';

import ReferralRequestForm from './ReferralRequestForm';
import {
  INVITED,
  INVITER,
} from 'scenes/PlayersActivities/PlayersInformation/constants';

const ReferralRequest = (props) => {
  const handleSubmit = async (values) => {
    props?.onSubmit(values);
  };

  return (
    <ReferralRequestForm
      {...props}
      initialValues={{
        [INVITER]: true,
        [INVITED]: false,
      }}
      onSubmit={handleSubmit}
    />
  );
};

export default ReferralRequest;
